import { Item } from "../models/DepartmentData/Item";
import { Declarant } from "../models/Declarant";
import { Rounded } from "./round";

interface CostFields {
  guarantee_cost?: number | null;
  epi_cost?: number | null;
  t1?: number | null;
  services_sum?: {
    EUR?: string | number;
  } | null;
}

export const getConsignmentItemsSum = (result: number, item: Item): number => {
  if (Array.isArray(item.children)) {
    return item.children.reduce(getConsignmentItemsSum, result);
  }

  return result + (item.consignment_items || 0);
};

export const getWarrantySum = (result: number, item: Item): number => {
  if (Array.isArray(item.children)) {
    return item.children.reduce(getWarrantySum, result);
  }

  return result + Number(item.warranty || 0);
};

export const getEpiCost = (entity: Declarant): number | null =>
  Rounded.of(
    (Number(entity.department_data?.one_code) || 0) +
      (entity.consignment_items - 1) *
        (Number(entity.department_data?.next_code) || 0) || null,
    2
  ).value ?? null;

export const getTotalCost = (entity: Declarant, round = 2): number | null => {
  return (
    Rounded.of(
      (getEpiCost(entity) || 0) +
        (Number(entity.department_data?.guarantee_cost) || 0),
      round
    ).value || null
  );
};

export const getCustomGroupTotalCost = (
  departmentData?: CostFields,
  round = 2
): number | null => {
  return (
    Rounded.of(
      (Number(departmentData?.guarantee_cost) || 0) +
        (Number(departmentData?.epi_cost) || 0) +
        (Number(departmentData?.t1) || 0) +
        (Number(departmentData?.services_sum?.EUR) || 0),
      round
    ).value || null
  );
};
